/** * For disabling iOS background scroll ** */
/** * Set html position fixed style and window offset when e.g. modal is shown and restore it afterwards ** */

/** * SET: */
/** * Step 1: Store window scroll position */
/** * Step 2: Store html and body inline styles */
/** * Step 3: Set html document style to be position fixed and preserve stored scroll position */

/** * RESTORE: */
/** * Restore html and body inline styles and preserve stored scroll position */

export default class PageScrollManager {
  get htmlStyle() {
    return document.documentElement.style;
  }

  get bodyStyle() {
    return document.body.style;
  }

  set() {
    this.scrollPosition = window.scrollY;
    this.initialHtmlStyle = {
      position: this.htmlStyle.position,
      inset: this.htmlStyle.inset,
    };
    this.initialBodyStyle = {
      position: this.bodyStyle.position,
      top: this.bodyStyle.top,
    };

    // Must come after storing scrollPosition
    this.htmlStyle.position = 'fixed';
    this.htmlStyle.inset = '0';
    this.bodyStyle.position = 'relative';
    this.bodyStyle.top = `${-this.scrollPosition}px`;
  }

  restore() {
    Object.assign(this.htmlStyle, this.initialHtmlStyle);
    Object.assign(this.bodyStyle, this.initialBodyStyle);

    // Must come after restoring styles
    window.scrollTo(0, this.scrollPosition);
  }
}
